import { BaseEdge, Position, getBezierPath } from '@xyflow/react';
import { memo } from 'react';
import { EdgeProps } from '../types';

const CustomEdge = ({
  id,
  data,
  source,
  sourceHandleId,
  target,
  targetHandleId,
  sourceX,
  sourceY,
  targetX,
  targetY,
  selected,
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX: sourceX - 8,
    sourceY,
    sourcePosition: Position.Right,
    targetX: targetX + 8,
    targetY,
    targetPosition: Position.Left,
    curvature: 0.16,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke:
            selected || data?._connectedNodeIsHovering ? '#2970FF' : '#D0D5DD',
          strokeWidth: 2,
        }}
      />
      {/* <EdgeLabelRenderer></EdgeLabelRenderer> */}
    </>
  );
};

export default memo(CustomEdge);
